import { useWatch } from "react-hook-form";
import { Link} from "react-router-dom";
import { IFormValues } from "../../../../../../types";
import { useHasScope } from "../../../../../../../../../../config/globalConfig";
import { BookingScope } from "../../../../../../../../types";
import { useTranslation } from "react-i18next";

const RateHelperText = () => {

    const hasScope = useHasScope;
    const { t } = useTranslation('booking');
    
    const rateId = useWatch<IFormValues, 'otherDetails.rateId'>({
        name: 'otherDetails.rateId'
    });


    return (
        <>
            {hasScope(BookingScope.ViewRates) && !!rateId && 
                <Link
                    to={`/pricing/rate/base-rates?id=${rateId}`}
                    target="_blank"
                    style={{color: "black"}} 
                >
                    {t("label.detail")}
                </Link>
            }
        </>
    
    )

}

export default RateHelperText;